import { CheckCircledIcon, CopyIcon } from '@radix-ui/react-icons';
import {
    Button,
    Dialog,
    Flex,
    IconButton,
    Text,
    TextField,
} from '@radix-ui/themes';

interface Props {
    title: string;
    description: string;
    result: string | undefined;
    closeLabel: string;
    onClose: () => void;
}

export const DeliverySuccessView = ({
    title,
    description,
    result,
    closeLabel,
    onClose,
}: Props) => {
    const isUrl = result?.startsWith('http');
    return (
        <Flex direction='column' align='center' gap='4' py='4'>
            <CheckCircledIcon width='48' height='48' color='var(--green-9)' />
            <Dialog.Title align='center'>{title}</Dialog.Title>
            <Text color='gray' size='2' align='center'>
                {description}
            </Text>

            {isUrl && (
                <TextField.Root
                    size='3'
                    value={result}
                    readOnly
                    style={{ width: '100%' }}
                >
                    <TextField.Slot side='right'>
                        <IconButton
                            variant='ghost'
                            color='gray'
                            onClick={() =>
                                navigator.clipboard.writeText(result!)
                            }
                        >
                            <CopyIcon />
                        </IconButton>
                    </TextField.Slot>
                </TextField.Root>
            )}

            <Button size='3' mt='2' onClick={onClose}>
                {closeLabel}
            </Button>
        </Flex>
    );
};
